import { render, staticRenderFns } from "./CategorySection.vue?vue&type=template&id=1cddaeb8&scoped=true&"
import script from "./CategorySection.vue?vue&type=script&lang=js&"
export * from "./CategorySection.vue?vue&type=script&lang=js&"
import style0 from "./CategorySection.vue?vue&type=style&index=0&id=1cddaeb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cddaeb8",
  null
  
)

export default component.exports